/**
 * Permission module (px-databases P3-53958, code `remotecommands`, userCode 380), child of
 * `oemdata`. `child::parent` makes HasPermission require both codes on the account role;
 * a sub-user also needs userCode 380 in their role.
 */
export const REMOTE_COMMANDS_PERMISSION = 'remotecommands::oemdata';
export const REMOTE_COMMANDS_USER_CODE = 380;
export const FINAL_STATUSES = ['SUCCEEDED', 'FAILED', 'TIMED_OUT', 'REJECTED'];
export const ACTIVE_STATUSES = ['SUBMITTED', 'IN_PROGRESS'];
export const LOCK_DOOR = 'LOCK_DOOR';
export const UNLOCK_DOOR = 'UNLOCK_DOOR';
/** Commands per page of the Command history tab (infinite scroll). */
export const HISTORY_PAGE_SIZE = 25;
/** The current command is the first page of size 1. */
export const LATEST_LIMIT = 1;
/**
 * Status check of the current command while it is active (there is no backend
 * poller): automatic every 5 s for the first minute, then manual, at most every 20 s.
 */
export const STATUS_CHECK_INTERVAL_MS = 5000;
export const STATUS_AUTO_CHECK_WINDOW_MS = 60000;
export const STATUS_MANUAL_CHECK_COOLDOWN_MS = 20000;
/**
 * How long an active command blocks a new one for the same vehicle (backend
 * REMOTE_COMMANDS_LOCK_WINDOW_S, 180 s): after it, Lock / Unlock are enabled again.
 */
export const ACTIVE_LOCK_WINDOW_MS = 180000;
/** Tab ids inside OemDataModal (adapters must not reuse them). */
export const REMOTE_COMMANDS_TAB = 'remoteCommands';
export const REMOTE_COMMAND_HISTORY_TAB = 'remoteCommandHistory';
/** `payload.type` of the Notification item the backend pushes on a final status. */
export const REMOTE_COMMAND_NOTIFICATION_TYPE = 'VehicleRemoteCommand';

/**
 * `all(unitId)` prefixes both per-unit queries: `latest` (array of ≤ 1 row,
 * the current command) and `history` (infinite query, pages of rows).
 */
export const remoteCommandKeys = {
	one: (id) => ['remoteCommand', String(id)],
	all: (unitId) => ['remoteCommands', Number(unitId)],
	latest: (unitId) => ['remoteCommands', Number(unitId), 'latest'],
	history: (unitId) => ['remoteCommands', Number(unitId), 'history'],
};

export const isActiveStatus = (status) => ACTIVE_STATUSES.includes(status);
